import React, { useState } from 'react';
import { styled } from 'styled-components';

import { ScheduleParam } from 'containers/ProductRegist/hooks/types';
import { ScheduleState } from 'types/api';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import OptionContainer from 'containers/ProductRegist/components/OptionSelectRegist/components/OptionContainer';
import ConfirmDialog from 'components/Modal/ConfirmDialog';
import { useMutationScheduleStatus } from 'containers/ProductDetail/graphQL/hooks/useMutationScheduleStatus';

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 12px;
  border: none;
  background: #f7f7f8;
`;

interface Props {
  scheduleItem: ScheduleParam;
  handleGetProductScheduleTerm: () => void;
  onClose: () => void;
}

const CalendarSchedule = (props: Props) => {
  const { scheduleItem, handleGetProductScheduleTerm, onClose } = props;

  const { handleOpenSchedule, handlePauseSchedule } =
    useMutationScheduleStatus();

  const [isOpenConfirmDialog, setIsOpenConfirmDialog] =
    useState<boolean>(false);

  const renderScheduleModifyForm = (): JSX.Element => {
    switch (scheduleItem.status) {
      case ScheduleState.OPENED: {
        return (
          <Container>
            <Row
              gap="4px"
              onClick={() => {
                setIsOpenConfirmDialog(true);
              }}
            >
              <Text color="#414B56" size="16px" weight={600}>
                일시 중지하기
              </Text>
            </Row>
          </Container>
        );
      }
      case ScheduleState.PAUSED: {
        return (
          <Container>
            <Row
              gap="4px"
              onClick={() => {
                setIsOpenConfirmDialog(true);
              }}
            >
              <Text color="#414B56" size="16px" weight={600}>
                다시 판매하기
              </Text>
            </Row>
          </Container>
        );
      }
    }
  };

  const renderConfirmModal = (): JSX.Element => {
    switch (scheduleItem.status) {
      case ScheduleState.OPENED: {
        return (
          <ConfirmDialog
            title="선택한 일정의 판매를 일시 중지 할까요?"
            description="일시 중지 시 크루에게 상품이 노출되지 않아요. 판매중 상태로 변경 시 다시 판매를 시작할 수 있어요."
            onCloseText="아니요"
            onClose={() => {
              setIsOpenConfirmDialog(false);
            }}
            onAcceptText="네, 일시 중지 할게요"
            onAccept={() => {
              setIsOpenConfirmDialog(false);
              handlePauseSchedule(scheduleItem.id, () => {
                handleGetProductScheduleTerm();
                onClose();
              });
            }}
          />
        );
      }
      case ScheduleState.PAUSED: {
        return (
          <ConfirmDialog
            title="선택한 일정의 판매를 다시 시작 할까요?"
            description="일시 중지 시 크루에게 상품이 노출되지 않아요. 판매중 상태로 변경 시 다시 판매를 시작할 수 있어요."
            onCloseText="아니요"
            onClose={() => {
              setIsOpenConfirmDialog(false);
            }}
            onAcceptText="네, 다시 시작 할게요"
            onAccept={() => {
              setIsOpenConfirmDialog(false);
              handleOpenSchedule(scheduleItem.id, () => {
                handleGetProductScheduleTerm();
                onClose();
              });
            }}
          />
        );
      }
    }
  };

  return (
    <>
      {renderScheduleModifyForm()}
      {isOpenConfirmDialog && renderConfirmModal()}
    </>
  );
};

export default CalendarSchedule;
